import { RestablecerContrasenaForm } from '../ui/RestablecerContrasenaForm';
import { ZafiroLogo } from '@/shared/components/ZafiroLogo';
import '../ui/LoginForm.css';

export const RestablecerContrasena = () => {
    return (
        <div className="login-container">
            <div className="login-content">
                {/* Logo fuera del formulario */}
                <div className="login-logo-section">
                    <ZafiroLogo />
                </div>

                <div className="login-card">
                    {/* Header */}
                    <div className="login-header">
                        <h1>Nueva Contraseña</h1>
                        <p>Ingresa tu nueva contraseña</p>
                    </div>

                    <div className="login-form-content">
                        <RestablecerContrasenaForm />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RestablecerContrasena;
